import { useState } from 'react';
import { authService } from '../utils/auth.ts';

interface LoginFormProps {
  onLoginSuccess: () => void;
  onSwitchToJoin?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  onLoginSuccess,
  onSwitchToJoin,
}) => {
  const [loginId, setLoginId] = useState('');
  const [loginCode, setLoginCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!loginCode.trim()) return;

    setIsLoading(true);
    setError('');

    try {
      await authService.login(loginCode, loginId.trim() || undefined);
      onLoginSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'ログインに失敗しました');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'var(--neutral-100)',
      }}
    >
      <div
        style={{
          backgroundColor: 'var(--bg-card)',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          width: '100%',
          maxWidth: '400px',
        }}
      >
        <h1
          style={{
            textAlign: 'center',
            marginBottom: '2rem',
            color: 'var(--text-primary)',
          }}
        >
          みといて
        </h1>
        <p
          style={{
            textAlign: 'center',
            marginBottom: '2rem',
            color: 'var(--text-secondary)',
          }}
        >
          グループ専用写真共有アプリ
        </p>

        <form onSubmit={handleSubmit} autoComplete="on">
          <div style={{ marginBottom: '1.5rem' }}>
            <label
              htmlFor="loginId"
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: 'bold',
                color: 'var(--text-primary)',
              }}
            >
              ログインID（任意）
            </label>
            <input
              id="loginId"
              name="username"
              type="text"
              value={loginId}
              onChange={e => setLoginId(e.target.value)}
              placeholder="設定済みの場合のみ入力"
              autoComplete="username"
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid var(--border-light)',
                borderRadius: '4px',
                fontSize: '1rem',
                boxSizing: 'border-box',
              }}
              disabled={isLoading}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label
              htmlFor="loginCode"
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: 'bold',
                color: 'var(--text-primary)',
              }}
            >
              ログインコード
            </label>
            <input
              id="loginCode"
              name="password"
              type="password"
              value={loginCode}
              onChange={e => setLoginCode(e.target.value)}
              placeholder="ログインコードを入力"
              autoComplete="current-password"
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '1px solid var(--border-light)',
                borderRadius: '4px',
                fontSize: '1rem',
                boxSizing: 'border-box',
              }}
              disabled={isLoading}
              required
            />
          </div>

          {error && (
            <div
              style={{
                marginBottom: '1rem',
                padding: '0.75rem',
                backgroundColor: 'var(--error-bg)',
                border: '1px solid var(--error-border)',
                borderRadius: '4px',
                color: 'var(--error)',
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading || !loginCode.trim()}
            style={{
              width: '100%',
              padding: '0.75rem',
              backgroundColor:
                isLoading || !loginCode.trim()
                  ? 'var(--interactive-disabled)'
                  : 'var(--info)',
              color: 'var(--neutral-50)',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1rem',
              cursor:
                isLoading || !loginCode.trim() ? 'not-allowed' : 'pointer',
              marginBottom: onSwitchToJoin ? '1rem' : '0',
            }}
          >
            {isLoading ? 'ログイン中...' : 'ログイン'}
          </button>

          {onSwitchToJoin && (
            <button
              type="button"
              onClick={onSwitchToJoin}
              style={{
                width: '100%',
                padding: '0.75rem',
                backgroundColor: 'transparent',
                color: 'var(--success)',
                border: '1px solid var(--success)',
                borderRadius: '4px',
                fontSize: '1rem',
                cursor: 'pointer',
              }}
            >
              初めての方：グループに参加
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
